<template>
  <el-dialog
    :title="model.id > 0 ? '编辑仓库' : '新增仓库'"
    :visible.sync="visible"
    label-width="100px"
    width="40%"
    @close="$emit('update:show', false)"
  >
    <el-form :model="model" :rules="rules" ref="form" label-width="100px" size="small">
      <el-form-item label="名称" label-width="100px" prop="name">
        <el-input v-model="model.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="地址" label-width="100px" prop="address">
        <el-input v-model="model.address" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="负责人" label-width="100px">
        <el-select v-model="model.user_id" filterable placeholder="请选择" style="width: 100%">
          <el-option v-for="item in users" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="备注" label-width="100px" prop="remark">
        <el-input v-model="model.remark" autocomplete="off" type="textarea"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="submitForm">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { createStockroom, updateStockroom, userList } from '@/service/getData'

export default {
  props: {
    model: {
      type: Object
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    }
  },
  data() {
    return {
      visible: this.show,
      users: [],
      rules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' },
          { min: 2, max: 15, message: '长度在 2 到 15 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.initData()
  },
  methods: {
    async initData() {
      let res = await userList({ page: 0, size: 1000 })
      if (res.code == 0) {
        this.users = res.data.list
      }
    },
    submitForm() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          if (this.model.user_id == '') {
            this.model.user_id = 0
          }
          if (this.model.id > 0) {
            delete this.model.user
            let res = await updateStockroom(this.model)
            if (res.code == 0) {
              this.$emit('updated', res.data)
            }
          } else {
            let res = await createStockroom(this.model)
            if (res.code == 0) {
              this.$emit('created', res.data)
            }
          }
          this.visible = false
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>